import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { beforeItems, afterItems } from "../data/landing";
export function BeforeAfter() {
  return <Section cta="Discover the Complete System" data-id="element-36" data-mp="3ogj6zexei0ex">
      <SectionHeading eyebrow="From clinical uncertainty to a more structured professional approach" title={<>
            You Have the Training. <span className="text-gold" data-id="element-38" data-mp="3ep6h2sv5xkbj">You Need a System</span> to Organize What You Know.
          </>} intro={<>
            <p data-id="element-39" data-mp="3jihmqqo8nv1v">
              You may have invested years in learning facial anatomy, injection techniques, patient assessment, and
              aesthetic procedures.
            </p>
            <p className="mt-4" data-id="element-40" data-mp="39osjk4r6tsrr">
              But when a patient presents an unexpected reaction, when your clinical findings are unclear, or when you
              need to review a complicated case, having information scattered across courses, notes, and reference
              materials can make the process more difficult.
            </p>
            <p className="mt-4" data-id="element-41" data-mp="t3i4wklzdo5d">
              That is the problem I wanted to address when I developed HOF CLINICAL BLUEPRINT™ — bringing essential
              educational concepts, structured assessment tools, and clinical safety references together in one
              organized library.
            </p>
          </>} data-id="element-37" data-mp="3ohuarequj861" />

      <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-42" data-mp="eelz6u7ecn7x">
        <div className="rounded-3xl bg-panel/60 p-6 ring-1 ring-alert/30 sm:p-8" data-id="element-43" data-mp="9fr4atw5n87g">
          <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-alert" data-id="element-44" data-mp="o3m04j5glsor">Before</p>
          <h3 className="mt-2 font-serif text-2xl font-bold text-cream sm:text-3xl" data-id="element-45" data-mp="jdfacfz7o24x">
            Before HOF CLINICAL BLUEPRINT™
          </h3>
          <ul className="mt-6 space-y-4" data-id="element-46" data-mp="3rre5jfeczjhd">
            {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-47" data-mp="3msukribi4dql">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/15 text-alert" data-id="element-48" data-mp="1qqr4e75eqjya">
                  <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-49" data-mp="1vp10cjyyhoky" />
                </span>
                <span className="text-base leading-snug text-muted" data-id="element-50" data-mp="20hlr1cmkflk9">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-panel p-6 ring-2 ring-gold/60 sm:p-8" data-id="element-51" data-mp="24k8lzmej9mlo">
          <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-52" data-mp="17tg4qlfv5oib">After</p>
          <h3 className="mt-2 font-serif text-2xl font-bold text-cream sm:text-3xl" data-id="element-53" data-mp="1crri365dah5a">With HOF CLINICAL BLUEPRINT™</h3>
          <ul className="mt-6 space-y-4" data-id="element-54" data-mp="1gr8mdw92588v">
            {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-55" data-mp="1lt7rbakg4d7x">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold text-ink" data-id="element-56" data-mp="2s7yujkx1ka54">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-57" data-mp="2x5s1ig66586g" />
                </span>
                <span className="text-base font-medium leading-snug text-cream" data-id="element-58" data-mp="379f7hzpe7jnw">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-2xl border-l-4 border-gold pl-5 text-left" data-id="element-59" data-mp="2xkou7rowk99l">
        <p className="font-serif text-xl font-semibold italic leading-snug text-cream sm:text-2xl" data-id="element-60" data-mp="2tjbpjkxjqc49">
          My goal is not to replace your clinical judgment.
        </p>
        <p className="mt-2 text-base leading-relaxed text-muted sm:text-lg" data-id="element-61" data-mp="2oi5vnjs5git5">
          My goal is to help you organize your knowledge into a more consistent, structured approach to facial
          aesthetic practice.
        </p>
      </div>
    </Section>;
}